import { Component, signal } from '@angular/core';

import { Environment } from '../../../environments/environment';
import { Middleton } from './middleton/middleton';
import { TheVillages } from './the-villages/the-villages';

@Component({
  imports: [Middleton, TheVillages],
  selector: 'app-site-header',
  templateUrl: './site-header.html',
})
export class SiteHeader {
  protected readonly header = signal(Environment.isApp ? 'app' : Environment.community);
}
